(() => {
  'use strict';

  const openRequestedTier = () => {
    const url = new URL(window.location.href);
    const tier = Number.parseInt(url.searchParams.get('tier'), 10);
    if (![15, 20, 25, 30, 35].includes(tier)) return;

    const button = document.querySelector(`[data-tier-choice="${tier}"]`);
    if (!button || button.disabled) return;

    url.searchParams.delete('tier');
    window.history.replaceState({}, '', `${url.pathname}${url.search}#customize`);
    button.click();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openRequestedTier, { once: true });
  } else {
    openRequestedTier();
  }
})();
